
import { defineComponent, ref, watch, onMounted, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'

import Moment from 'moment'
import Config from '@/utils/config'

import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    name: 'Dialog',
    computed: {
        ...mapState(['dialogData', 'activityData'])
    },
    setup () {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const COVER = _this.proxy.$common

        const btnClick = (btn: any) => {
            if (btn.className === 'wxAuthorize-btn') {
                wxAuthorize()
                COVER.track('click', '绑定微信')
            } else if (btn.className === 'download-btn') {
                downloadApp()
                COVER.track('click', '下载app')
            } else if (btn.className === 'update-btn') {
                update()
                COVER.track('click', '升级app')
            } else if (btn.className === 'login-btn') {
                login(btn)
                COVER.track('click', '登录')
            } else if (btn.className === 'bindmobile-btn') {
                bindMobile(btn)
                COVER.track('click', '绑定手机号')
            } else if (btn.className === 'getJifen-btn') {
                COVERAPP.Method.goIntegralTask()
                COVER.track('click', '去积分任务页面')
                $store.commit('SET_DIALOGDATA', null)
            } else if (btn && btn.callback) {
                btn.callback()
            } else {
                $store.commit('SET_DIALOGDATA', null)
            }
        }

        // 吊起微信授权
        const wxAuthorize = () => {
            COVERAPP.Method.wxAuthorize({
                callback(res: any) {
                    let data = typeof res == 'string'.toLowerCase() ? res : JSON.stringify(res)
                    if (JSON.parse(data).status == 1) {
                        const openid = JSON.parse(data).openid
                        let verifyOpenid = `${$store.state.userInfo.user_id.toString(36)}_${openid}_${(+Moment().format("YYYYMMDD")).toString(36)}`
                        let userInfo = JSON.parse(JSON.stringify($store.state.userInfo))
                        userInfo.openid = openid
                        $store.commit('SET_USERINFO', userInfo)
                        bindWeixin(verifyOpenid)
                        $store.commit('SET_DIALOGDATA', null)
                    }
                }
            })
        }

        // 绑定微信
        const bindWeixin = (openid: string) => {
            _this.proxy.$request('/user/weixin/bind', {
                openid: openid,
                userinfo: $store.state.userInfo
            }, 'put').then(() => {
                COVER.toast('绑定微信成功')
            }).catch((res: any) => {
                if (res.errno == 1251) {
                    $store.commit('SET_DIALOGDATA', {
                        text: '亲，您的微信号已授权，不能重复授权哦！',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                } else {
                    COVER.toast('绑定微信失败')
                }
            })
        }

        const downloadApp = () => {
            if ($store.state.activityData.openApp) {
                COVER.downloadApp($store.state.activityData.openApp.news_id, $store.state.activityData.openApp.flag)
            }     
        }

        // 版本升级
        const update = () => {
            if (COVERAPP.Attribute.isIOS()) {
                window.location.href = 'https://itunes.apple.com/cn/app/id1028293650'
            } else if (COVERAPP.Attribute.isAndroid()) {
                COVER.loadjs(Config.DOWNLOAD_ADDRESS).then(()=> {
                    window.location.href = window.download_url
                })                
            }
        }

        // 登录
        const login = (btn: any) => {
            COVERAPP.Method.OpenLogin({
                callback (ret: any) {
                    let userinfo = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret
                    if (!COVER.isEmpty(userinfo.token)) {
                        COVER.getUser((res: any) => {
                            $store.commit('SET_USERINFO', res)
                            setTimeout(() => {
                                if (btn.callback) {
                                    btn.callback()
                                } else {
                                    $store.commit('SET_DIALOGDATA', null)
                                } 
                            }, 200)
                        })       																													
                    }
                }
            })
        }

        // 绑定手机号
        const bindMobile = (btn: any) => {
            COVERAPP.Method.bindMobile({
                callback(res: any) {
                    const result = typeof res != 'string' ? JSON.stringify(res) : res
                    if (result.indexOf('success') > -1) {
                        COVER.getUser((res: any) => {
                            $store.commit('SET_USERINFO', res)
                            if (btn.callback) {
                                btn.callback()
                            } else {
                                $store.commit('SET_DIALOGDATA', null)
                            }
                        })
                    }                    
                }
            })
        }

        return {
            btnClick
        }
    }
})
